<template>
  <span v-show="$store.getters['app/overlays'].show_start_selector_overlay">
    <img draggable="false" @click="goToHome()" id="top_quit_btn" src="./../assets/images/Asset 31.png" alt="">

    <span id="true_counter_text">Golven gestopt: <span v-html="golves_clicked"></span>/<span v-html="max_golves_to_click"></span></span>

    <span v-for="(item, index) in items" :key="item.id">
      <img draggable="false" v-if="item.id == 31 && item.visible" @click="despawnGolf(index)" class="golf clickable" src="./../assets/images/splash/Asset 31.png" alt="">
      <img draggable="false" v-else-if="item.id == 32 && item.visible" @click="despawnGolf(index)" class="golf clickable" src="./../assets/images/splash/Asset 32.png" alt="">
      <img draggable="false" v-else-if="item.id == 33 && item.visible" id="golf_3" @click="despawnGolf(index)" class="golf clickable" src="./../assets/images/splash/Asset 33.png" alt="">
      <img draggable="false" v-else-if="item.id == 34 && item.visible" id="golf_4" @click="despawnGolf(index)" class="golf clickable" src="./../assets/images/splash/Asset 34.png" alt="">
      <img draggable="false" v-else-if="item.id == 35 && item.visible" @click="despawnGolf(index)" class="golf clickable" src="./../assets/images/splash/Asset 35.png" alt="">
      <img draggable="false" v-else-if="item.id == 36 && item.visible" @click="despawnGolf(index)" class="golf clickable" src="./../assets/images/splash/Asset 36.png" alt="">
    </span>

    <!-- <span id="golf_section" @click="generateGolf()"></span> -->
  </span>
</template>

<script>
import swal from 'sweetalert2'

export default {
  name: "Golven",
  mounted() {
    let that = this
    setInterval(function() {
      that.generateGolf()
    }, 2000)
  },

  created() {},
  destroyed() {},

  data() {
    return {
      golves_clicked: 0,
      max_golves_to_click: 4,
      items: [
        {
          id: 31,
          visible: true
        }
      ],
    };
  },

  methods: {
    goToHome() {
      this.$router.push('/');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: true,
          show_start_selector_overlay: false,
      });
    },

    resetGame() {
      this.golves_clicked = 0;
    },

    gameEnd() {
      var that = this
      new swal({
          allowEscapeKey: false,
          allowOutsideClick: false,
          title: "",
          html: `<p class='swal_html'>Goed zo!</p>`,
          type: "success",
          showCancelButton: true,
          cancelButtonColor: '#d33',
          cancelButtonText: 'Terug',
          confirmButtonColor: "#9BCB3C",
          confirmButtonText: "Opnieuw spelen",
        }).then(function (confirm) {
          if ( confirm.isConfirmed ) {
            that.resetGame()
          } else {
            that.goToHome()
          }
        });
    },
    
    generateGolf() {
      this.items.push({
        id: (Math.floor(Math.random() * 5) + 31 ),
        visible: true
      })
    },

    despawnGolf(index) {
      // console.log(this.items[index]);
      // delete this.items[index];
      this.items[index].visible = false;

      this.golves_clicked++;
    }
  },

  computed: {},

  watch: {
    golves_clicked: function(value) {
      if ( value >= this.max_golves_to_click ) {
        this.gameEnd();
      }
    }
  }
};
</script>

<style>
/* https://www.w3schools.com/css/tryit.asp?filename=trycss3_animation2 */
  /* #golf_section {
    width: 100%;
    height: 41%;
    margin-top: 33%;
    left: 0%;
    position: absolute;
    cursor: url('./../assets/cursor/material-wood-pointer.png'), default;	
  } */

  .golf {
    position: absolute;
    left: -10%;
    margin-top: 27%;
    width: 10%;
    animation-name: golf_animation;
    animation-duration: 10s;
    opacity: 0;
  }

  #golf_3 {
    width: 5%;
    margin-top: 29%;
  }

  @keyframes golf_animation {
    0%{
      left: 0%;
    }
    2%{
      opacity: 1;
    }
    98% {
      left: 70%;
      opacity: 1;
    }
    100% {
      left: 70%;
      opacity: 0;
    }
  }
</style>


